export interface KeyTextPair {
  key: string;
  text: string;
  code?: string;
  colName?: string;
  sortOrder?: number;
  color?: string;
  required?: boolean;
}

export class KeyTextPairUtils {
  static getByText<T extends KeyTextPair>(text: string, items: T[]): T | undefined {
    return items.find((item) => item.text === text);
  }

  static getAllTextValues<T extends KeyTextPair>(items: T[]): string[] {
    return items.filter((item) => item && item.text).map((item) => item.text);
  }

  static getByKey<T extends KeyTextPair>(key: string, items: T[]): T | undefined {
    return items.find((item) => item.key === key);
  }

  static getByCode<T extends KeyTextPair>(code: string, items: T[]): T | undefined {
    return items.find((item) => item.code === code);
  }

  static getByColName<T extends KeyTextPair>(colName: string, items: T[]): T | undefined {
    return items.find((item) => item.colName === colName);
  }
}
